import GlobalVariable from '@/global/global-variable'

// 报警查询
const searchAlarmApi = GlobalVariable.BASE_PATH + '/rest/alarm/search';
// 报警状态查询
const findAlarmStatusApi = GlobalVariable.BASE_PATH + '/rest/alarm/findAlarms';
// 报警处理
const dealAlarmApi = GlobalVariable.BASE_PATH + '/rest/alarm/dealAlarm';
// 查询预警
const searchEarlyApi = GlobalVariable.BASE_PATH + '/rest/system/early/search';
// 查询预警类型
const findEarlyTypeApi = GlobalVariable.BASE_PATH + '/rest/system/early/findEarlyType';
// 查询服务器ip
const findServerIpApi = GlobalVariable.BASE_PATH + '/rest/system/early/findServerIp';

export default {
    searchAlarmApi,
    findAlarmStatusApi,
    dealAlarmApi,
    searchEarlyApi,
    findEarlyTypeApi,
    findServerIpApi
}



// WEBPACK FOOTER //
// ./src/request/api-alarm-gnss.js